class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.watchEmptyState();
  }

  /* --- estado "carrito vacio" ------------------------------------------
     La clase is-empty va en <cart-drawer> (esta misma etiqueta), pero las
     actualizaciones por AJAX solo reemplazan lo de ADENTRO (#CartDrawer o
     .drawer__inner), asi que la clase del contenedor se queda pegada.
     Consecuencia: si vacias el carrito y despues agregas algo, el drawer
     queda con el layout de "vacio" (se esconde el encabezado y no se ve la
     lista) hasta recargar la pagina; y al reves, si sacas el ultimo
     producto, no aparece el mensaje de carrito vacio.
     Aca la clase se deduce del contenido real y se mantiene sincronizada,
     sin importar quien actualice el drawer. */
  syncEmptyState() {
    this.classList.toggle('is-empty', !!this.querySelector('.drawer__inner-empty'));
  }

  watchEmptyState() {
    this.syncEmptyState();
    new MutationObserver(() => this.syncEmptyState()).observe(this, {
      childList: true,
      subtree: true,
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
          const cartDrawerItems = this.querySelector('cart-drawer-items');
    if (cartDrawerItems) {
      cartDrawerItems.updateCartUpsellToggleState();
      cartDrawerItems.updateCartUpsellVisibility();
    }

    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    this.syncEmptyState();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ============================================================================
   AJUSTES STEPSTYLE DEL CAJON  (23 y 24-sep-2026)
   ----------------------------------------------------------------------------
   Dos cosas viven aqui abajo:
     A) el campo "Codigo de descuento" del cajon;
     B) la barra de envio gratis movida a la zona que se desplaza.

   POR QUE ESTA EN ESTE ARCHIVO Y NO EN EL LIQUID DEL CAJON
   snippets/cart-drawer.liquid pesa 47 KB y maneja todo el carrito. Tocarlo
   obliga a reescribirlo entero y cualquier error ahi se lleva puesto el
   checkout. Este archivo ya venia cargado junto con el cajon y es chico. Los
   estilos estan en assets/component-cart-drawer.css, al final.

   ----------------------------------------------------------------------------
   LA REGLA QUE NO SE ROMPE  (leer antes de tocar nada)

   Hubo aqui una funcion que bajaba el carrusel de jibbitz (.cc-upsell) dentro
   del pie del cajon, copiando como se ve el carrito de Zephyra. En computador
   se veia bien. EN CELULAR ROMPIO EL CARRITO: el pie paso a medir 585 px de
   los 740 utiles de un telefono, y a la lista de productos le quedaron 6 px.
   El cliente veia el carrusel, el seguro, el cupon y el total, pero NO veia lo
   que estaba comprando, y no podia desplazarse.

   El error de fondo fue copiar la estructura del referente sin ver que el pie
   de StepStyle lleva mas cosas que el de ellos: bloque de seguro de envio,
   linea de cuotas y sello de pago seguro. En su carrito cabe; en este no.

   NO MOVER ELEMENTOS HACIA EL PIE. Todo lo que se agrega ahi se le resta al
   espacio donde el cliente ve sus productos, y en celular ese espacio es poco.

   Mover elementos EN SENTIDO CONTRARIO (del area fija hacia la zona que se
   desplaza) es lo opuesto y es seguro: hace que el area fija pese menos. Eso
   es exactamente lo que hace el punto B.
   ----------------------------------------------------------------------------

   COMO SE APLICA UN CUPON  (comprobado en la tienda el 23-09-2026)
   La API de carrito de Shopify NO tiene metodo para cupones. Lo que si
   funciona:
       aplicar -> fetch('/discount/CODIGO')
       quitar  -> fetch('/cart/update.js', { discount: '' })

   DOS TRAMPAS QUE YA COSTARON UN ERROR, NO LAS REPITAS:

   1) Un codigo que NO existe igual responde 200. No sirve mirar el estado
      HTTP. Hay que volver a leer el carrito y revisar si el descuento
      aparecio de verdad.

   2) Los descuentos automaticos (los "Pack crocs - 2 / 3 o mas pares") se ven
      EXACTAMENTE IGUAL que un cupon en los datos del carrito: los dos llegan
      como discounts dentro de cada linea. Si se pintan todos como etiquetas
      con una X para quitarlos, el cliente ve una X al lado del descuento del
      pack, la toca, y no pasa nada, porque un descuento automatico no se
      puede sacar.
      Por eso solo se muestra como etiqueta el codigo que el cliente escribio
      en esta sesion (guardado en sessionStorage) y los descuentos a nivel de
      pedido completo, que en esta tienda siempre vienen de un cupon.

   OJO CON LOS PACKS: si el carrito ya trae el descuento de pack, Shopify se
   queda con el que mas le conviene al cliente y el cupon puede no entrar. Eso
   no es una falla: el mensaje se lo explica.
   ============================================================================ */
(function () {
  var CLAVE = 'ssc-cupon';
  var OCUPADO = false;

  function guardado() {
    try {
      return sessionStorage.getItem(CLAVE) || '';
    } catch (e) {
      return '';
    }
  }

  function guardar(codigo) {
    try {
      if (codigo) sessionStorage.setItem(CLAVE, codigo);
      else sessionStorage.removeItem(CLAVE);
    } catch (e) {
      /* Navegacion privada o almacenamiento bloqueado: se sigue igual, solo
         que la etiqueta no sobrevive a un refresco. El descuento si. */
    }
  }

  function dinero(centavos) {
    try {
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        maximumFractionDigits: 0,
      }).format(centavos / 100);
    } catch (e) {
      return '$' + Math.round(centavos / 100);
    }
  }

  function leerCarrito() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  /* Devuelve { TITULO_EN_MAYUSCULAS: { titulo, monto, deNivelPedido } }.
     Un mismo descuento puede venir a nivel de pedido Y repartido por linea.
     Si se suman los dos lados, el monto sale al doble. Por eso, cuando ya
     vino a nivel de pedido, lo de las lineas se ignora. */
  function descuentosDe(carrito) {
    var mapa = {};

    (carrito.cart_level_discount_applications || []).forEach(function (d) {
      if (!d || !d.title) return;
      var clave = String(d.title).toUpperCase();
      if (!mapa[clave]) mapa[clave] = { titulo: d.title, monto: 0, deNivelPedido: true };
      mapa[clave].monto += d.total_allocated_amount || 0;
    });

    (carrito.items || []).forEach(function (item) {
      (item.discounts || []).forEach(function (d) {
        if (!d || !d.title) return;
        var clave = String(d.title).toUpperCase();
        if (mapa[clave] && mapa[clave].deNivelPedido) return;
        if (!mapa[clave]) mapa[clave] = { titulo: d.title, monto: 0, deNivelPedido: false };
        mapa[clave].monto += d.amount || 0;
      });
    });

    return mapa;
  }

  /* Repinta el cajon con el carrito nuevo usando el mismo mecanismo que el
     tema usa al cambiar una cantidad, para que totales, precios tachados y
     barra de envio gratis queden todos al dia. */
  function refrescarCajon() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (secciones) {
        var doc = new DOMParser();

        if (secciones['cart-drawer']) {
          var nuevo = doc
            .parseFromString(secciones['cart-drawer'], 'text/html')
            .querySelector('.drawer__inner');
          var actual = document.querySelector('cart-drawer .drawer__inner');
          if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
        }

        if (secciones['cart-icon-bubble']) {
          var burbujaNueva = doc
            .parseFromString(secciones['cart-icon-bubble'], 'text/html')
            .querySelector('.shopify-section');
          var burbuja = document.getElementById('cart-icon-bubble');
          if (burbujaNueva && burbuja && burbuja.parentElement) {
            burbuja.parentElement.innerHTML = burbujaNueva.innerHTML;
          }
        }
      })
      .catch(function () {
        /* Si el repintado falla, el descuento igual quedo aplicado y se vera
           en el checkout. No vale la pena romper el cajon por esto. */
      });
  }

  function mensaje(caja, texto, esError) {
    var p = caja.querySelector('.ssc-cupon__msg');
    if (!p) return;
    p.textContent = texto || '';
    p.className = 'ssc-cupon__msg' + (esError ? ' ssc-cupon__msg--error' : '');
  }

  function quitar(caja) {
    if (OCUPADO) return;
    OCUPADO = true;
    mensaje(caja, 'Quitando…');
    guardar('');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' }),
    })
      .then(refrescarCajon)
      .then(function () {
        OCUPADO = false;
      })
      .catch(function () {
        OCUPADO = false;
        mensaje(caja, 'No se pudo quitar. Intenta de nuevo.', true);
      });
  }

  /* Solo se pintan: el codigo que el cliente escribio en esta sesion, y los
     descuentos a nivel de pedido completo. Los descuentos automaticos de pack
     quedan fuera a proposito (ver la nota grande de arriba). */
  function pintarEstado(caja, carrito) {
    var contenedor = caja.querySelector('.ssc-cupon__aplicados');
    if (!contenedor) return;

    var mapa = descuentosDe(carrito);
    var mio = guardado().toUpperCase();
    var mostrar = [];

    Object.keys(mapa).forEach(function (clave) {
      if (mapa[clave].deNivelPedido || clave === mio) mostrar.push(mapa[clave]);
    });

    contenedor.innerHTML = '';
    mostrar.forEach(function (d) {
      var chip = document.createElement('span');
      chip.className = 'ssc-cupon__chip';
      chip.textContent = d.titulo + (d.monto ? ' −' + dinero(d.monto) : '');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ssc-cupon__quitar';
      btn.setAttribute('aria-label', 'Quitar ' + d.titulo);
      btn.textContent = '×';
      btn.addEventListener('click', function () {
        quitar(caja);
      });

      chip.appendChild(btn);
      contenedor.appendChild(chip);
    });
  }

  function aplicar(caja) {
    if (OCUPADO) return;
    var input = caja.querySelector('.ssc-cupon__input');
    var boton = caja.querySelector('.ssc-cupon__btn');
    var codigo = (input.value || '').trim();

    if (!codigo) {
      mensaje(caja, 'Escribe un código primero.', true);
      input.focus();
      return;
    }

    OCUPADO = true;
    boton.disabled = true;
    mensaje(caja, 'Aplicando…');

    var antes = 0;

    leerCarrito()
      .then(function (carrito) {
        antes = Object.keys(descuentosDe(carrito)).length;
        return fetch('/discount/' + encodeURIComponent(codigo), { redirect: 'follow' });
      })
      .then(leerCarrito)
      .then(function (carrito) {
        var mapa = descuentosDe(carrito);
        var entro = !!mapa[codigo.toUpperCase()];

        OCUPADO = false;
        boton.disabled = false;

        if (entro || Object.keys(mapa).length > antes) {
          guardar(codigo.toUpperCase());
          input.value = '';
          mensaje(caja, '');
          return refrescarCajon();
        }

        mensaje(
          caja,
          'No se pudo aplicar. Puede que el código no exista o que no se combine con el descuento que ya tiene tu carrito.',
          true
        );
      })
      .catch(function () {
        OCUPADO = false;
        boton.disabled = false;
        mensaje(caja, 'No se pudo aplicar. Revisa tu conexión.', true);
      });
  }

  function construir() {
    var caja = document.createElement('div');
    caja.className = 'ssc-cupon';
    caja.innerHTML =
      '<div class="ssc-cupon__fila">' +
      '<input type="text" class="ssc-cupon__input" name="ssc-cupon" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="Código de descuento" aria-label="Código de descuento">' +
      '<button type="button" class="ssc-cupon__btn">Aplicar</button>' +
      '</div>' +
      '<p class="ssc-cupon__msg"></p>' +
      '<div class="ssc-cupon__aplicados"></div>';

    caja.querySelector('.ssc-cupon__btn').addEventListener('click', function () {
      aplicar(caja);
    });

    /* Enter aplica el cupon. Se frena la propagacion para que el formulario
       del carrito no se mande solo al checkout. */
    caja.querySelector('.ssc-cupon__input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        aplicar(caja);
      }
    });

    return caja;
  }

  /* El cupon va justo antes de los totales. Con el carrito vacio el pie no
     existe y no se pone nada. Es lo UNICO que se agrega al pie: cualquier cosa
     mas que se meta ahi le quita espacio a la lista de productos en celular. */
  function colocar() {
    var pie = document.querySelector('cart-drawer .drawer__footer');
    if (!pie) return;
    if (pie.querySelector('.ssc-cupon')) return;

    var caja = construir();
    var totales = pie.querySelector('.cart-drawer__footer');
    if (totales) pie.insertBefore(caja, totales);
    else pie.appendChild(caja);

    leerCarrito()
      .then(function (carrito) {
        pintarEstado(caja, carrito);
      })
      .catch(function () {});
  }

  /* --------------------------------------------------------------------------
     B) BARRA DE ENVIO GRATIS DENTRO DE LA ZONA QUE SE DESPLAZA  (24-sep-2026)

     De fabrica la barra (.cc-goals) queda entre el encabezado y la lista, en
     la parte fija del cajon. En un telefono se come 105 px que no se
     recuperan nunca: estan tomados aunque el cliente ya haya alcanzado el
     envio gratis.

     El carrito de referencia la lleva dentro de lo que se desplaza, junto con
     los productos. Medido el 24-09 en su tienda: su zona de contenido tiene
     518 px en un telefono de 740, contra los 222 px que tenia StepStyle.

     Aqui se hace lo mismo: se mueve la barra al principio del contenido que
     se desplaza. Sigue siendo lo primero que ve el cliente al abrir el
     carrito, y vuelve a la vista al subir, pero deja de robar alto fijo.

     Esto es mover algo DESDE el area fija HACIA la que se desplaza, o sea lo
     contrario del error que rompio la v13. El pie no crece ni un pixel.
     -------------------------------------------------------------------------- */
  function subirBarraDeEnvio() {
    var cajon = document.querySelector('cart-drawer');
    if (!cajon) return;

    var barra = cajon.querySelector('.cc-goals');
    var contenido = cajon.querySelector('.drawer__contents');
    if (!barra || !contenido) return;

    /* Ya esta movida. Esta guarda es la que impide que el observador de mas
       abajo se muerda la cola, porque mover un nodo dispara el observador. */
    if (contenido.contains(barra)) return;

    var primero = contenido.querySelector('.drawer__cart-items-wrapper') || contenido.firstElementChild;
    if (primero) contenido.insertBefore(barra, primero);
    else contenido.appendChild(barra);
  }

  function acomodar() {
    colocar();
    subirBarraDeEnvio();
  }

  /* Shopify repinta el cajon entero cada vez que cambia el carrito y eso borra
     el cupon inyectado y devuelve la barra a su lugar original. El observador
     rehace las dos cosas. Las guardas de arriba (si ya esta hecho, no hace
     nada) evitan que esto se muerda la cola. */
  function vigilar() {
    var cajon = document.querySelector('cart-drawer');
    if (!cajon) return;
    acomodar();
    new MutationObserver(function () {
      acomodar();
    }).observe(cajon, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vigilar);
  } else {
    vigilar();
  }
})();